import { useCallback } from "react";

import RepPortalSearchItem from "../models/repPortalSearchItem";
import { useRepPortalApi } from "./repPortalApi";

export function useRepSearchApi() {
	const { Get } = useRepPortalApi();

	const loadSearches = useCallback(
		function () {
			return Get<RepPortalSearchItem[]>("PortalMetaSearch");
		},
		[Get],
	);

	return { loadSearches };
}
